import { makeStyles } from 'tss-react/mui';

export default makeStyles({ name: 'Breadcrumbs' })({
    root: {
        color: '#232323',
        fontSize: 14,
        fontWeight: 500,
        lineHeight: '16px'
    },
    separator: {
        color: '#ECECEC'
    },
    link: {
        color: 'inherit',
        ['&:hover']: {
            color: '#F5726A'
        }
    }
});
